"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewCustomField extends new_item_1.default {
    constructor(newCustomField) {
        super();
        this.customFieldTypeId = newCustomField.customFieldTypeId;
        this.customFieldType = newCustomField.customFieldType;
        this.customFieldName = newCustomField.customFieldName;
        this.siteIds = newCustomField.siteIds;
        this.icon = newCustomField.icon;
        this.colour = newCustomField.colour;
        this.valueText = newCustomField.valueText;
        this.valueNumber = newCustomField.valueNumber;
        this.valueBoolean = newCustomField.valueBoolean;
        this.valueTimestamp = newCustomField.valueTimestamp;
        this._permission = newCustomField._permission;
    }
}
exports.default = NewCustomField;
//# sourceMappingURL=new-customField.js.map